import React, { useContext } from 'react';
import queryString from 'query-string-for-all';
import { AppContext } from 'src/components/app-context';
import { ListItem } from 'src/components/list-item';
import { getSortedQuery } from '@prisjakt/product-collection-urls';
import { getTranslationForSortOption } from './sort-options';
import { trackProductCollectionSortUpdate } from '../../tracking';

import { OverlayWrapper } from 'src/components/filter-overlay/components/overlay';

type Props = {
  currentSort: string;
  onClose: () => void;
  sortOptions: string[];
  sortTranslations: Record<string, string>;
};

const OverlaySort = ({
  currentSort,
  onClose,
  sortOptions,
  sortTranslations,
}: Props) => {
  const { t } = useContext(AppContext);

  if (!sortOptions.length) {
    return null;
  }

  const currentSortName = getTranslationForSortOption(
    currentSort,
    sortTranslations,
    t
  );

  function handleOnClick(sortOption: string) {
    trackProductCollectionSortUpdate(sortOption);
    onClose();
  }

  return (
    <OverlayWrapper onClose={onClose} title={t('common', 'sorting.title')}>
      {sortOptions.map(sortOption => {
        const queryParams = getSortedQuery({
          ...queryString.parse(location.search.replace(/^\?/, '')),
          offset: undefined,
          direction: undefined,
          sort: sortOption,
        });

        const sortNameTranslation = getTranslationForSortOption(
          sortOption,
          sortTranslations,
          t
        );

        return (
          <ListItem
            key={sortOption}
            link={`${location.pathname}?${queryString.stringify(queryParams)}`}
            name={sortNameTranslation}
            showArrow={false}
            onClick={() => handleOnClick(sortOption)}
            disabled={sortNameTranslation === currentSortName}
          />
        );
      })}
    </OverlayWrapper>
  );
};

export default OverlaySort;
